import React, { useState } from 'react'
import Box from '@mui/material/Box'
import { NavLink, useNavigate, Outlet } from 'react-router-dom'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme, styled } from '@mui/material/styles'
import Drawer from '@mui/material/Drawer'
import { MdMenu, MdKeyboardDoubleArrowRight } from 'react-icons/md'
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
const Header = () => {
    const [open, setOpen] = useState()
    const theme = useTheme()
    const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'))
    const navigate = useNavigate()
    // Drawer functions
    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setOpen(open);
    };

    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    }));
    const list = (anchor) => (
        <Box
            sx={{ width: 250, }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                {['/', 'Packages','Menu'].map((text, index) => (
                    <ListItem key={index} disablePadding>
                        <ListItemButton>
                            <ListItemText primary={text === '/' ? 'Home' : text} onClick={() => navigate((text === '/') ? "/" : `/${text}`)} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    const handleDrawerClose = () => {
        setOpen(false)
    }

    return (
        <>{isMobileScreen ?
            <>
                <Box component={'div'} zIndex={'999999999'} className='position-sticky top-0' >
                    <div className='d-flex w-100' style={{ backgroundColor: 'whitesmoke' }}>
                        <div className='w-100 d-flex align-item-center justify-content-between'>
                            <Box component={'img'} className='my-3 mx-2' width={isMobileScreen ? '100px' : '200px'} height={'50%'} src={isMobileScreen ? require('../../Assets/mk-mobile-logo.webp') : require('../../Assets/logo-no-background.png')} alt='logo' />
                            <Box component={'button'} zIndex={''} height={'fit-content'} className='my-2 mx-2 rounded-2 mb-2 p-2 border-0' onClick={toggleDrawer(true)} ><MdMenu color='#127f3b' className='fs-3' /></Box>
                        </div>
                    </div>
                    <Drawer anchor={'right'} open={open} onClose={toggleDrawer(false)} sx={{ zIndex: '9999999999' }}>
                        <DrawerHeader>
                            <IconButton onClick={handleDrawerClose} sx={{ marginRight: '80%' }}>
                                <MdKeyboardDoubleArrowRight color='#127f3b' className='fs-3' />
                            </IconButton>
                        </DrawerHeader>
                        {list()}
                    </Drawer>
                </Box>

            </>
            :
            <Box component={'div'} zIndex={'999999999'} className='header-container d-flex align-items-center justify-content-between position-sticky top-0 w-100' boxShadow={'0px 0px 3px black'}>
                <Box component={'img'} className='mx-2' width={'200px'} height={'100%'} src={require('../../Assets/logo-no-background.png')} alt='logo' />
                <div className='d-flex gap-3 mx-5'>
                    <div>
                        <NavLink to={'/'} className='nav-link text-capitalize'>home</NavLink>
                    </div>
                    <div>
                        <NavLink to={'/packages'} className='nav-link text-capitalize'>packages</NavLink>
                    </div>
                    {window.location.pathname !== '/packages' &&
                        < div >
                            <a href='#contact-form' className='nav-link text-capitalize'>Contact us</a>
                        </div>
                    }
                    <div>
                        <NavLink to={'/Menu'} className={'nav-link text-capitalize'}>Menu</NavLink>
                    </div>
                </div>
            </Box >
        }
            <Outlet />
        </>
    )
}

export default Header